<form #userForm="ngForm" (ngSubmit)=onSubmit(userForm) class="m-auto auth auth-background" >
    <div class="container-fluid">
      <div class="row pi-login  justify-content-center align-items-center">
        <div class="col-md-12 ">
          <div class="header-w3l">
            <div class="logo ml-2">
              <h3 class="d-flex justify-content-center align-items-center "><a href="#"><img src="./assets/images/Group1.png" alt=""></a></h3>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5  text-center d-flex justify-content-center">
            <div class="w-25 mob-tab d-flex justify-content-center forgot-center">
              <div class="forgot">Forgot Password</div>
            </div>
          </div>
        <div class="col col-sm-6 col-md-7 col-lg-3 text-center mt-4" >
          <label for="" class="d-flex justify-content-start">  {{'PLACEHOLDER.EMAIL' | translate}}</label>
          <div class="form-group mb-2 ">
            <i class="fa fa-envelope text-white input-icon" aria-hidden="true"></i>
            <input type="text" [(ngModel)]="user.username" class="form-control" name="username"
            #username="ngModel" placeholder="{{ 'PLACEHOLDER.EMAIL' | translate }}" maxlength="120" required autofocus>
          </div>
            <div *ngIf="userForm.submitted && username.invalid" class="text-left pt-0">
              <p class="error-msg mb-0">{{ 'FORMERROR.EMAIL' | translate }}</p>
            </div>
          <div class="d-flex justify-content-end forgot-password" routerLink="/login">Login here</div>
          <div class="row justify-content-center align-items-center mt-3">
            <div class="col-md-5 w-50">
              <button class="forgot-btn btn mr-5" type="submit" [disabled]="isLoading" >
                {{ 'BUTTON.SUBMIT_BTN' | translate }}
                <div *ngIf="isLoading" class="spinner-border spinner-border-sm fs-14" role="status">
                  <span class="sr-only">{{ 'COMMON.LOADING' | translate }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>